// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__oltw-","info":"UpdateTermsInfo_info__3y-ZC"};